import { render, staticRenderFns } from "./FormTooltip.vue?vue&type=template&id=35923ab9&"
import script from "./FormTooltip.vue?vue&type=script&lang=js&"
export * from "./FormTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports